module.exports = __webpack_public_path__ + "media/standardized_tests/sticky_03-e46c11ca.jpg";